import { RouteRecordRaw } from "vue-router";

export const enrollerRouter: RouteRecordRaw = {
  path: "/enroll",
  redirect: "level",
  component: () => import("@/layout/EmptyLayout.vue"),
  children: [
    {
      path: "level/:studyLevel",
      name: `enroll-level`,
      component: () => import("@/views/enroll/Enroll.vue"),
    },
  ],
};
